import React, { useState } from 'react';

import GabineteForm from '../components/frigorificos/GabineteForm';
import PuertaForm from '../components/frigorificos/PuertaForm';
import AccesorioForm from '../components/frigorificos/AccesorioForm';
import MaterialesFrioForm from '../components/frigorificos/MaterialesFrioForm';
import MaterialesElectricosForm from '../components/frigorificos/MaterialesElectricosForm';
import UnidadCondensadoraForm from '../components/frigorificos/UnidadCondensadoraForm';
import ForzadorForm from '../components/frigorificos/ForzadorForm';

export default function ComponentesPage() {
    const [activeTab, setActiveTab] = useState('gabinete');

    const tabs = [
        { key: "gabinete", label: "Gabinete" },
        { key: "puerta", label: "Puerta" },
        { key: "accesorio", label: "Accesorio" },
        { key: "materialesFrio", label: "Materiales Frío" },
        { key: "materialesElectricos", label: "Materiales Eléctricos" },
        { key: "unidadCondensadora", label: "Unidad Condensadora" },
        { key: "evaporadorCubico", label: "Evaporador Cúbico" }
    ];

    return (
        <div className="page-wrapper">
            <h2 className="page-title">
                Gestión de Componentes: <span>{activeTab}</span>
            </h2>

            {/* Botonera estilizada */}
            <div className="component-tabs">
                {tabs.map(tab => (
                    <button
                        key={tab.key}
                        className={activeTab === tab.key ? "active" : ""}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Render dinámico del formulario */}
            <div className="component-content">
                {activeTab === "gabinete" && <GabineteForm />}
                {activeTab === "puerta" && <PuertaForm />}
                {activeTab === "accesorio" && <AccesorioForm />}
                {activeTab === "materialesFrio" && <MaterialesFrioForm />}
                {activeTab === "materialesElectricos" && <MaterialesElectricosForm />}
                {activeTab === "unidadCondensadora" && <UnidadCondensadoraForm />}
                {activeTab === "evaporadorCubico" && <ForzadorForm />}
            </div>
        </div>
    );
}
